export const HOME = {
    emergentLink: "home-emergent-link",
    heroSearch: "home-hero-search-input",
    heroSearchBtn: "home-hero-search-btn",
    categoryToggleAll: "filter-category-all",
    categoryTogglePhysical: "filter-category-physical",
    categoryToggleMental: "filter-category-mental",
    objectiveWellness: "filter-objective-wellness",
    objectiveCompetition: "filter-objective-competition",
    cityInput: "filter-city-input",
    remoteSwitch: "filter-remote-switch",
    priceSlider: "filter-price-slider",
    coachCard: "coach-card",
    exploreFeed: "nav-explore-feed",
    openDashboard: "nav-open-dashboard",
    loginBtn: "nav-login-btn",
    logoutBtn: "nav-logout-btn",
};

export const COACH = {
    bookBtn: "coach-book-btn",
    bookForm: "coach-book-form",
    bookName: "coach-book-name",
    bookEmail: "coach-book-email",
    bookMessage: "coach-book-message",
    bookSubmit: "coach-book-submit",
    meritScore: "coach-merit-score",
    goals: "coach-goals",
    rating: "coach-rating",
    retention: "coach-retention",
};

export const DASH = {
    profileTab: "dash-tab-profile",
    studentsTab: "dash-tab-students",
    uploadsTab: "dash-tab-uploads",
    saveProfile: "dash-save-profile",
    uploadStudent: "dash-upload-student",
    uploadDuration: "dash-upload-duration",
    uploadHeadline: "dash-upload-headline",
    uploadMediaUrl: "dash-upload-media-url",
    uploadConsent: "dash-upload-consent",
    uploadSubmit: "dash-upload-submit",
};

export const LOGIN = {
    googleBtn: "login-google-btn",
    roleClient: "role-select-client",
    roleCoach: "role-select-coach",
};
